import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Icon, Paragraph } from 'components/patterns'
import { themeColor } from 'utils/styles'
import { timerValue } from 'utils/timers'
import strings from 'utils/strings'
import AnimatedHourglass from './AnimatedHourglass'

export const StyledIcon = styled(Icon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  font-size: 18px;
  margin-right: 10px;
  color: ${themeColor('featureHeaderIconColor')};
`

const DelaySimulationContainer = styled.span`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${({ delaying }) =>
      delaying ? 'space-evenly' : 'flex-end'};
    position: absolute;
    top: 4px;
    right: 0;
    width: calc(100% - 248px);
    ${({ delaying }) =>
      delaying ? '' : `${AnimatedHourglass} { margin-right: 6px; }`}
    p {
      line-height: 12px;
      margin-top: 2px;
      width: auto;
      text-overflow: initial;
      white-space: break-spaces;
      text-align: right;
    }
  }
`

const DelayValues = styled.span`
  font-size: 10px;
  font-weight: bold;
  line-height: 12px;
  width: 100%;
  position: absolute;
  right: 0;
  top: 110%;
  text-align: right;
  span:first-of-type {
    border: 1px solid ${themeColor('slatePrimary')};
    background-color: ${themeColor('whitePressed')};
    padding: 1px 2px;
  }
  span:last-of-type {
    white-space: nowrap;
  }
`

const NodeDelayIndicator = ({
  hasTimerDelay,
  isSimulating,
  countdown,
  outputting,
  playing,
  delayActivate,
  delayDeactivate,
}) => {
  if (!hasTimerDelay) {
    return null
  }
  const delayTypeStr = outputting
    ? strings.deactivate_delay
    : strings.activate_delay

  const delaySetValue = outputting ? delayDeactivate : delayActivate
  const delaying = isSimulating && countdown > 0
  return (
    <DelaySimulationContainer delaying={delaying}>
      {delaying && <Paragraph size="xsmall">{delayTypeStr}</Paragraph>}
      <AnimatedHourglass playing={playing} disabled={!delaying} />
      {delaying && (
        <DelayValues>
          <span>{timerValue(countdown)}</span>
          <span>{` / ${timerValue(delaySetValue)}`}</span>
        </DelayValues>
      )}
    </DelaySimulationContainer>
  )
}

NodeDelayIndicator.propTypes = {
  hasTimerDelay: PropTypes.bool,
  isSimulating: PropTypes.bool,
  countdown: PropTypes.number,
  outputting: PropTypes.bool,
  playing: PropTypes.bool,
  delayActivate: PropTypes.number,
  delayDeactivate: PropTypes.number,
}

export default NodeDelayIndicator
